export default __webpack_public_path__ + "static/media/wallet.2a37a454.svg";